import { computed, ref, onMounted, onUnmounted } from 'vue'

/** Server time is the baseline. Elapsed time also catches up after background throttling. */
export const useActivityCountdown = (
  options: { queryTime: string, endTime: string },
  activity: ProductV3.SelectedSkuActivity,
  onOver: (activity: ProductV3.SelectedSkuActivity) => void,
  format: (milliseconds: number) => { hour: string, minute: string, second: string }
) => {
  const serverDuration = new Date(options.endTime).getTime() - new Date(options.queryTime).getTime()
  const duration = Number.isFinite(serverDuration) ? Math.max(0, serverDuration) : 0
  const remaining = ref(duration)
  const day = computed(() => remaining.value / 86400000)
  const isOver = computed(() => remaining.value <= 0)
  const countdown = computed(() => format(remaining.value))
  const identity = { ...activity }
  let interval: ReturnType<typeof setInterval> | undefined
  onMounted(() => {
    const startedAt = performance.now()
    let emitted = false
    const tick = () => {
      remaining.value = Math.max(0, duration - (performance.now() - startedAt))
      if (remaining.value <= 0 && !emitted) {
        emitted = true
        clearInterval(interval)
        onOver(identity)
      }
    }
    if (remaining.value > 0) interval = setInterval(tick, 1000)
    tick()
  })
  onUnmounted(() => clearInterval(interval))
  return { day, isOver, countdown }
}
